module.exports = __webpack_public_path__ + "img/JPN.196a502f.svg";